'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createEagerFactory = require('recompose/createEagerFactory');

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var leaveScope = function leaveScope(BaseComponent) {
  var factory = (0, _createEagerFactory2.default)(BaseComponent);

  var RemoveScope = function (_React$Component) {
    _inherits(RemoveScope, _React$Component);

    function RemoveScope(props, context) {
      _classCallCheck(this, RemoveScope);

      var _this = _possibleConstructorReturn(this, (RemoveScope.__proto__ || Object.getPrototypeOf(RemoveScope)).call(this, props, context));

      _this.state = {};
      _this.scope = (0, _utils.selectScope)(context);
      return _this;
    }

    _createClass(RemoveScope, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.scope.notifyOutBound = function () {
          return _this2.setState({});
        };
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.scope.notifyOutBound = null;
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return _defineProperty({}, _utils.SCOPE, this.context[_utils.SCOPE].slice(0, -1));
      }
    }, {
      key: 'render',
      value: function render() {
        var _selectScope = (0, _utils.selectScope)(this.context),
            outerProps = _selectScope.outerProps,
            consume = _selectScope.consume,
            expose = _selectScope.expose,
            namespace = _selectScope.namespace;

        return factory(_extends({}, consume(outerProps), namespace ? _defineProperty({}, namespace, expose(this.props)) : expose(this.props)));
      }
    }]);

    return RemoveScope;
  }(_react2.default.Component);

  RemoveScope.contextTypes = _utils.scopeContextTypes;
  RemoveScope.childContextTypes = _utils.scopeContextTypes;

  return RemoveScope;
};

exports.default = leaveScope;


//////////////////
// WEBPACK FOOTER
// ./~/recompose-scope/leaveScope.js
// module id = 710
// module chunks = 0